export function stripAtSign(text: string) {
  return text.replace(/^@/, '');
}
